/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon20Solid = forwardRef('DataChartBarsAUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17 3.5a1 1 0 1 0-2 0v13a1 1 0 1 0 2 0v-13Z" }),
        React.createElement("path", { d: "M12 5.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M9 9a1 1 0 0 0-2 0v7.5a1 1 0 1 0 2 0V9Z" }),
        React.createElement("path", { d: "M5 12a1 1 0 1 0-2 0v4.5a1 1 0 1 0 2 0V12Z" })));
});
